import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";

export const LoginModal = ({ isLoginModal, setIsLoginModal }) => {
  const { t } = useTranslation();

  return (
    <Modal show={isLoginModal} onHide={(e) => setIsLoginModal(false)}>
      <Modal.Body>
        <div className="promocode_content login_first">
          <Link to="" onClick={(e) => setIsLoginModal(false)}>
            +
          </Link>
          <h2>{t("complete-profile-candidate")}</h2>
          <img src={window.location.origin + "/images/landing.png"} />
          <p>{t("answer-question-help")}</p>
          <button>
            <Link to={"/complete-parents-profile"}>
              {t("text-complete-profile")}
            </Link>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
